module.exports = __webpack_public_path__ + "img/volume_up.19be0e6a.svg";